import { IconButton } from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import { CloseButtonProps } from 'react-toastify/dist/components';
import { Icon } from '../Icon';

export const CloseToastButton = ({ closeToast }: CloseButtonProps) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
  <IconButton
    aria-label={t('close-toast')!}
    boxSize={10}
    icon={<Icon name="close" color="neutral.300" />}
    onClick={closeToast}
    variant="unstyled"
  />
  );
};
